function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustpilotStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 132.8 24.9"
    },
    viewBox: "0 0 132.8 24.9",
    className: "h-3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.9v24.9H0V0zm27 0h24.9v24.9H27V0zm26.9 0h24.9v24.9H53.9V0zm27 0h24.9v24.9H80.9V0zm27 0h24.9v24.9h-24.9V0z",
    style: {
      fill: "#00b67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4 16.8 3.8-1 1.6 4.9-5.4-3.9zm8.7-6.3h-6.7l-2-6.3-2 6.3H3.7l5.4 3.9-2 6.3 5.4-3.9 3.3-2.4 5.3-3.9zm18.3 6.3 3.8-1 1.6 4.9-5.4-3.9zm8.7-6.3h-6.7l-2-6.3-2 6.3h-6.7l5.4 3.9-2 6.3 5.4-3.9 3.3-2.4 5.3-3.9zm18.3 6.3 3.8-1 1.6 4.9-5.4-3.9zm8.7-6.3h-6.7l-2-6.3-2 6.3h-6.7l5.4 3.9-2 6.3 5.4-3.9 3.3-2.4 5.3-3.9zm18.2 6.3 3.8-1 1.6 4.9-5.4-3.9zm8.8-6.3h-6.7l-2-6.3-2 6.3h-6.7l5.4 3.9-2 6.3 5.4-3.9 3.3-2.4 5.3-3.9zm18.2 6.3 3.8-1 1.6 4.9-5.4-3.9zm8.7-6.3h-6.7l-2-6.3-2 6.3h-6.7l5.4 3.9-2 6.3 5.4-3.9 3.3-2.4 5.3-3.9z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStars);
export default __webpack_public_path__ + "static/media/trustpilot-stars.b32ae876321d4b8ed5fc2c72d5974fcc.svg";
export { ForwardRef as ReactComponent };